import {
  RESET_SCROLL_POSITION,
  SET_SCROLL_POSITION,
  REMOVE_NAVBAR_TOP,
  ACTIVE_NAVBAR_TOP,
} from "../types/scroll.types";
import { deepClone } from "../../utils/utils";

const initialState = {
  position: "",
  activeNav: false,
};

const reducer = function orderReducer(state = initialState, action) {
  const newState = deepClone(state);
  switch (action.type) {
    case SET_SCROLL_POSITION:
      const { position } = action;
      newState.position = position;
      return newState;
    case RESET_SCROLL_POSITION:
      newState.position = "";
      return newState;
    case REMOVE_NAVBAR_TOP:
      newState.activeNav = false;
      return newState;
    case ACTIVE_NAVBAR_TOP:
      newState.activeNav = true;
      return newState;
    default:
      return newState;
  }
};

export default reducer;
